export default {
    google: "https://www.googleapis.com/webfonts/v1/webfonts?fields=items(family,subsets,variants)&sort=popularity&key=AIzaSyCkNKP6mtIDquutPg3i8h0OCthkKxcC5QQ",
    zuu: "https://s3.eu-central-1.amazonaws.com/zuu-webfonts/fonts.json"
};